import React, { useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
export const OfflineShop = () => {
  const [price, setPrice] = useState(0);
  const [number, setNumber] = useState("");
  const [numberError, setNumberError] = useState("");
  const [priceError, setPriceError] = useState("");

  const saveShopData = () => {
    if (number.length > 0 && price > 0) {
      // save shop
      console.log("Shop data saved:", { number, price });
    } else {
      // Handle validation errors
      if (number.length === 0) {
        setNumberError("شماره همراه نمی‌تواند خالی باشد");
      }
      if (price <= 0) {
        setPriceError("مبلغ باید بیشتر از صفر باشد");
      }
    }
  };
  const schema = yup.object({
    mob: yup
      .string()
      .required("عنوان گروه انتخاب نشده است.")
      .min(3, "نام گروه نباید کمتر از 3 کاراکتر باشد"),
      price: yup.number().min(1,"مبلع باید به درستی وارد شود")
  });
  const defaultValues ={}
  const {
    watch,
    handleSubmit,
    control,
    register,
    setValue,
    reset,
    formState: { errors },
  } = useForm({ defaultValues, resolver: yupResolver(schema) });
  const onSubmit =()=>{}
  return (
    <div className="panel panel-body d-flex">
      <Form dir="rtl" onSubmit={handleSubmit(onSubmit)}>
        <Row>
          <Col className="col-12 col-lg-6">
            <Form.Group className="mb-3" controlId="formBasicPassword">
              <Form.Label>شماره همراه:</Form.Label>
              <Form.Control
                type="tel"
                value={number}
                onChange={(e) => {
                  setNumber(e.target.value);
                  setNumberError(""); // Clear error when user types
                }}
                required
              />
              {numberError && <div className="text-danger">{numberError}</div>}
            </Form.Group>
          </Col>
          <Col className="col-12 col-lg-6">
            <Form.Group className="mb-3" controlId="formBasicPassword">
              <Form.Label>مبلغ:</Form.Label>
              <Form.Control
                type="tel"
                value={price}
                onChange={(e) => {
                  setPrice(e.target.value);
                  setPriceError(""); // Clear error when user types
                }}
                required
              />
              {priceError && <div className="text-danger">{priceError}</div>}
            </Form.Group>
          </Col>
        </Row>
        <Row></Row>
        <Row>
          <Col className="col-12 col-lg-6">
            <div className="justify-content-center m-5">
              <Button variant="primary" onClick={saveShopData}>
                ذخیره
              </Button>
            </div>
          </Col>
        </Row>
      </Form>
    </div>
  );
};
